module.exports = __webpack_public_path__ + "img/secure-icon.e36699ad.svg";